import { PaletteMode, PaletteOptions, SimplePaletteColorOptions } from '@mui/material';
import tokens from '@skodaflow/web-tokens/src/tokens.json';

const skodaColors = tokens['flow-colors'];

export const createPaletteDark = (): PaletteOptions => ({
	mode: 'dark' as PaletteMode,
	skodaColors,
	secondary: { main: '#78FAAE', light: '#A8FFCC' } as SimplePaletteColorOptions,
	primary: { main: '#419468' },
	tertiary: { main: '#0E3A2F' },
	error: { main: '#E82B37' },
	action: { disabled: skodaColors['neutrals-chrome200'] },
	text: {
		primary: skodaColors['neutrals-white'],
		secondary: skodaColors['neutrals-chrome300'],
		disabled: skodaColors['neutrals-chrome500']
	},
	background: {
		default: skodaColors['neutrals-chrome800'],
		paper: skodaColors['neutrals-chrome700'],
		selected: 'rgba(0, 0, 0, 0.055)'
	},
	formControlLabel: '#b8b8b8',
	dropdownIcon: skodaColors['neutrals-white'],
	skodaLinkIcon: skodaColors['neutrals-white'],
	closeButton: {
		background: '#E4E4E4',
		color: skodaColors.text
	},
	scrollbar: {
		dark: '#C4C6C7',
		light: '#C4C6C7'
	},
	bulletPoints: skodaColors['neutrals-white'],
	chip: {
		backgroundPrimary: '#E8FFF1',
		backgroundSecondary: 'rgba(22, 23, 24, 0.06)',
		colorPrimary: '#419468',
		colorSecondary: skodaColors['neutrals-white'],
		colorPrimaryHover: '#59BC87',
		colorSecondaryHover: skodaColors['neutrals-chrome500']
	}
});
